import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Cards1 from './../block/Cards1'
import HideContentBlock from './../block/HideContentBlock'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import NetPhotoMiniBlock from './../block/NetPhotoMiniBlock'
import ProdukciyaDirs from './../block/ProdukciyaDirs'
import Showroom from './../block/Showroom'

class Ustanovka extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.oknacards || []}
          layout={7}
          cols={`2-all`}
          margin={`top`}
        />
        <HideContentBlock
          data={data?.hidecontent || {}}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
          margin={`top-bottom-10`}
        />
        <NetPhotoMiniBlock />
        <ProdukciyaDirs
          produkciya_page={data?.produkciya_page}
        />
        <Cards1
          title={`Работаем на качество и <span>несем <br />ответственность за свою работу</span>`}
          rtext={``}
          text={``}
          list={data?.nakachestvo || []}
          cols={1}
          margin={`top`}
          bg={1}
          layout={8}
        />
        <Showroom
          data={data?.showroom || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          assets_path={assets_path}
          margin={`y`}
        />
      </>
    )
  }
}

Ustanovka.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Ustanovka.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Ustanovka